import styled from "styled-components";

export const HighlightedText = styled.span`
  color: var(--textColor);
  font-weight: 600;
`;
